import { Checkbox as MuiCheckbox } from '@mui/material'
import { IconCheck } from 'assets/icons'
import { FormControlLabel } from 'elements/inputs/form/form-control-label'

import { StyledIcon } from './styled-icon'

export type Props = {
  checked: boolean
  onChange?: (checked: boolean) => void
  label?: React.ReactNode
  disabled?: boolean
  indeterminate?: boolean
  disablePointerEvents?: boolean
}

export const Checkbox = ({
  checked,
  onChange,
  disabled,
  indeterminate,
  label,
  disablePointerEvents,
}: Props) => {
  const control = (
    <MuiCheckbox
      color="primary"
      disableRipple
      checked={checked}
      onChange={event => {
        onChange?.(event.target.checked)
      }}
      disabled={disabled}
      icon={<StyledIcon />}
      indeterminate={indeterminate && !checked}
      indeterminateIcon={<StyledIcon>-</StyledIcon>}
      checkedIcon={
        <StyledIcon>
          <IconCheck
            sx={{
              width: 8,
              height: 10,
            }}
          />
        </StyledIcon>
      }
      sx={{
        p: 0,
      }}
    />
  )

  if (label) {
    return (
      <FormControlLabel
        label={label}
        control={control}
        sx={{ pointerEvents: disablePointerEvents ? 'none' : undefined }}
      />
    )
  }

  return control
}
